import React, { Component, Fragment } from 'react';
import Header from './schoolAdminHeader';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import setUpSchool from '../SetUpSchool/setUpSchool';
import DashBoard from '../Home/dashBoard'
import DashboardCharts from './dashboardCharts'
import account from '../Account/accountDetails'
import ManageSchool from '../SetUpSchool/manageSchool';
import ManagePayments from '../ManagePayments/ManagePayments';
import AddTransaction from '../Transactions/addTransaction';
import { get } from '../../../server/actions'
import NotificationSystem from 'react-notification-system';
import ViewOrders from '../Reports/ordersGrid';
import BulkOrders from '../Reports/bulkOrdersGrid';
import CreateMenu from '../Menu/mealCreate';
import YearMeal from '../Menu/yearMeal/yearMeal'
import OrderSnapshot from '../Reports/ordersGraph';
import ErrorBoundary from '../../Misc/Error'
import ViewReportsV2 from '../Reports/reportsV2';
import AdminReports from '../Reports/AdminReports/AdminReports';
import ViewMenuV2 from '../Menu/viewMenuV2';
import ItemAssign from '../Menu/posManagment/itemAssign';
import ViewMenu from '../../Parent/OrderMeals/viewMenu';
import OrderMenu from '../../Parent/ManageOrders/orderMenu';
import CancelOrder from '../Meals/cancelOrder';
import DataSync from '../DataSync/dataSync';
import ManageSchools from '../ManageSchools/manageSchools';
import SchoolYearRec from '../ManageSchools/schoolYearRec';
import ManageUsers from '../ManageUsers/manageUsers';
import PaymentReports from '../PaymentReports/paymentReport';
import ManageLunchBal from '../ManagePayments/ManageLunchBal';
import MealReport from '../Reports/MealReport';
import FinancialReport from '../Reports/FinancialReport';
import ClaimReport from '../Reports/CliamReport';
import LowBalEmailEntry from '../LowBalEmail/LowBalEmailEntry';
import { _addNotification, _addNotificationError, gradeTextToNumber } from "../../../server/util";
import {staffGrades } from '../../../server/constants';
import MenuMaster from '../Caterer/MenuMaster/menuMaster';
import MenuMasterList from '../Caterer/MenuMaster/menuMasterList';
import AlAcarte from '../Menu/alAcarte'
import NewMenu from '../Caterer/NewMenu/newMenu';
import ManagePackage from '../BcAc/ManagePackage';
import ManageBcAC from '../BcAc/ManageBcAc';
import { text2num } from '../../../server/word2number';
import QuickBar from './quickbar'
import SchoolLunchProgramList from '../SchoolMealProgram/schoolLunchPrgoramList';
import EventsList from '../ManageEvents/EventsList';
import EventRecord from '../ManageEvents/EventRecord';
import AccountHistory from '../PaymentReports/AccountHistory';
import POSLocation from '../Settings/posLocations';
import NutritionPage from '../Nutrition/NutritionPage';
import EnrollmentSummary from '../BcAc/ManageBcAc/enrollmentSummary';
import Enrollments from '../BcAc/ManageBcAc/enrollments';
import ImportCertification from '../ImportCertification';
import LunchSessions from '../LunchSessions';
import SessionRecord from '../LunchSessions/sessionRecord';
import DailyPOSCash from '../DailyPOSCash';
import ContactUS from '../contactUs/contactUs';
import BroadcastMessage from '../broadcastMessage';
import EligibilityCodes from '../eligibilityCodeSettings';
import DirectCertification from '../directCertificationSettings';
import EditEligibilityLetter from '../editEligibilityLetter';
import NotSubmittedNotification from '../notSubmittedNotification';
import StudentLookUp from '../SetUpSchool/studentLookUp';
/* import MenuCatalog from '../MenuCatalog'; */
import AutomateSchoolYear from '../ManageSchools/automateSchoolYear';
import NewLunchApplication from '../SchoolMealProgram/newLunchApplication';
import NewSchoolMealProgramApplication from '../SchoolMealProgram/newSchoolProgramApplication';
import StudentRegistration from '../Home/studentRegistration';
import Help from '../Help';
import BulkTransactions from '../Transactions/bulkTransactions';
import ESEAFormList from '../EseaForm';
import moment from 'moment';
import _ from 'lodash';
import SchoolYearForm from './schoolYearForm';
let grades = [];
//let grade = {};
//----demo purpose-----
let order = [];
let schoolMealId = 0;
let lType = '';
let loggedInUserInfo = {};
//-------------

class schoolAdmin extends Component {
    constructor() {
        super();
        this.state = {
            grades: [],
            orderMonthYear: '',
            showSchoolYearForm: false,
            selectedSchoolYear: undefined,
            futureSchoolYear: undefined,

        }
        this.review = this.review.bind(this);
        this.readSchoolMealId = this.readSchoolMealId.bind(this);
        this.sortGrade = this.sortGrade.bind(this);
        this.getOrderMonthYear = this.getOrderMonthYear.bind(this);
    }
    componentWillMount = () => {
        if ((sessionStorage.getItem('schoolYear') || '') === '')
            this.validateSchoolYear();
        else {

        }
    };
    initInfo = () => {
        let loginInfo = {}
        try {
            loginInfo = JSON.parse((sessionStorage.getItem('loggedInUserInfo') || '') === '' ? {} : sessionStorage.getItem('loggedInUserInfo'));
        } catch (ex) {
        }
        loggedInUserInfo = loginInfo;
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.initInfo();
        this.getSchoolGrade();
    }
    review(selection) {
        //alert("came ")
        order = selection;
    }
    readSchoolMealId(id, type) {
        schoolMealId = id;
        lType = type;
    }
    getOrderMonthYear(month_year) {
        this.setState({ orderMonthYear: month_year });
    }
    validateSchoolYear = () => {
        get('/schoolYears/search/findByMealSchoolSchoolId?mealSchoolId=' + sessionStorage.getItem("SchoolId") + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            // Spring Data REST omits _embedded entirely when the collection is empty,
            // which is exactly the no-school-year state this gate has to detect.
            const schoolYears = (data._embedded || {}).schoolYears || [];
            if (schoolYears.length === 0) {
                this.setState({ showSchoolYearForm: true });
            }
            else {
                const schoolYearList = schoolYears.map((item) => {
                    return {
                        ...item,
                        sessionStartDateTime: moment.utc(item.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss').local().format('YYYY-MM-DDThh:mm:ss'),
                        sessionEndDateTime: moment.utc(item.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss').local().format('YYYY-MM-DDThh:mm:ss')
                    }
                });
                //sessionStorage.setItem('schoolYearsList', JSON.stringify(data._embedded.schoolYears))
                let rec = _.filter(schoolYearList, function (o) {
                    const stDate = moment(moment(o.sessionStartDateTime, 'YYYY-MM-DDThh:mm:s')).startOf('day');
                    const nowDate = moment().toDate();
                    const endDate = moment(moment(o.sessionEndDateTime, 'YYYY-MM-DDThh:mm:s')).endOf('day');
                    return (stDate <= nowDate && endDate >= nowDate);
                });
                if (rec.length === 0) {
                    let futureRec = _.filter(schoolYearList, function (o) {
                        const stDate = moment(moment(o.sessionStartDateTime, 'YYYY-MM-DDThh:mm:s')).startOf('day');
                        const nowDate = moment();
                        return (stDate > nowDate);
                    });
                    if (futureRec.length > 0) {
                        let _futureSchoolYear = {};
                        _futureSchoolYear.name = futureRec[0].name;
                        _futureSchoolYear.schoolYear = futureRec[0].schoolYear;
                        _futureSchoolYear.rec = futureRec[0];
                        this.setState({ showSchoolYearForm: true, futureSchoolYear: _futureSchoolYear });
                    } else {
                        let latestSchoolYear = schoolYearList.reduce((latest, current) => {
                            const latestDate = new Date(moment(latest.sessionEndDateTime).local());
                            const currentDate = new Date(moment(current.sessionEndDateTime).local());
                            return currentDate > latestDate ? current : latest;
                        });
                        let _selectedSchoolYear = {};
                        _selectedSchoolYear.name = latestSchoolYear.name;
                        _selectedSchoolYear.schoolYear = latestSchoolYear.schoolYear;
                        _selectedSchoolYear.rec = latestSchoolYear;
                        this.setState({ showSchoolYearForm: true, selectedSchoolYear: _selectedSchoolYear });
                    }

                } else {
                    let selectedSchoolYear = this.state.selectedSchoolYear;
                    selectedSchoolYear.name = rec[0].name;
                    selectedSchoolYear.schoolYear = rec[0].schoolYear;
                    selectedSchoolYear.rec = rec[0];
                    sessionStorage.setItem('schoolYear', rec[0].name),
                        sessionStorage.setItem('schoolYearValue', rec[0].schoolYear)
                    this.setState({ selectedSchoolYear: selectedSchoolYear, showSchoolYearForm: false });
                }
                this.setState({ schoolYearList: schoolYearList });
            }
        }).catch(
            (error) => {
                console.log('Get School data response', error)
            }
        );
    }

    getSchoolGrade() {
        //  https://devapi2.mealmanage.com/mealManage/mealSchools/250/school?access_token=e455a4fa-f341-4616-84df-df98313d4c8a
        get('/mealSchools/' + sessionStorage.getItem("SchoolId") + '/school?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            /*  Object.values(data.typeGrades).forEach(function (value) {
                  value.forEach(item => {
                    grades.push(gradeTextToNumber(item));
                  });
              });
              const sortedList=this.sortGrade(grades)
              this.setState({ grades: sortedList })
              sessionStorage.setItem('grades',JSON.stringify(sortedList, null, 2)) */
            let grades = [];
            Object.values(data.typeGrades || {}).map(gds => {
                if (gds.length > 0)
                    grades = [...grades, ...gds];
            })
            sessionStorage.setItem('grades', JSON.stringify(grades, null, 2))
        }).catch(
            (error) => {
                console.log('Get School data response', error)
            }
        );
    }
    sortGrade(grade) {
        let resNo = [];
        let resNoNo = [];
        let staffArray = [];
        grade.forEach(function (val) {
            if (!isNaN(val))
                resNo.push(parseInt(val));
            else
                if (staffGrades.includes(val)) {
                    staffArray.push(val);
                } else {
                    resNoNo.push(val);
                }
        });
        for (let i = 0; i < resNo.length; i++) {
            for (let j = 0; j < resNo.length - i; j++) {
                if (resNo[j] > resNo[j + 1]) {
                    let tmp = resNo[j];
                    resNo[j] = resNo[j + 1];
                    resNo[j + 1] = tmp;
                }
            }
        }
        for (let k = resNoNo.length - 1; k >= 0; k--) {
            resNo.unshift(resNoNo[k]);
        }
        staffArray.forEach(item => {
            resNo.push(item)
        })
        return (resNo);
    }


    render() {

        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <Router>
                    <div id="scrollDiv" style={{ overflowY: 'scroll', overflowX: 'hidden', height: 'calc(100vh - 70px)' }}>
                        {!this.state.showSchoolYearForm && <Fragment>
                            <Header />
                            <QuickBar />
                        </Fragment>}

                        <ErrorBoundary>

                            {this.state.showSchoolYearForm ? <Fragment>
                                <Switch>
                                    <Route component={() => {
                                        const { showSchoolYearForm, selectedSchoolYear, futureSchoolYear } = this.state;
                                        return <SchoolYearForm currentSchoolYear={selectedSchoolYear} futureSchoolYear={futureSchoolYear} />
                                    }} /></Switch>
                            </Fragment> : <Fragment>
                                <Switch>
                                    <Route path="/schoolAdmin/setUpSchool" component={setUpSchool} />
                                    <Route path="/schoolAdmin/manageSchool"
                                        render={(rest) => <ManageSchool grades={this.state.grades} {...rest} />} />
                                    <Route path="/schoolAdmin/studentLookUp"
                                        render={() => <StudentLookUp grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/addTransaction"
                                        render={() => <AddTransaction grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/managePayments/:filter?/:grade?/:schoolYear?"
                                        render={() => <ManagePayments grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/mealReport"
                                        render={() => <MealReport />} />
                                    <Route path="/schoolAdmin/financialReport"
                                        render={(rest) => <FinancialReport   {...rest} grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/claimReport"
                                        render={() => <ClaimReport />} />
                                    <Route path="/schoolAdmin/manageLunchBalance"
                                        render={() => <ManageLunchBal />} />
                                    <Route path="/schoolAdmin/importCertificationData"
                                        render={() => <ImportCertification />} />
                                    <Route path="/schoolAdmin/events" render={() => <EventsList />} />
                                    <Route path="/schoolAdmin/eventRecord/:eid?" render={() => <EventRecord grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/viewOrders"
                                        render={() => <OrderSnapshot grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/bulkOrdersGrid"
                                        render={() => <BulkOrders />} />
                                    <Route path="/schoolAdmin/viewOrdersGrid/:filter?/:grade?/:monthYear?"
                                        render={() => <ViewOrders grades={this.state.grades} setMonthYear={this.getOrderMonthYear} />} />

                                    <Route path="/schoolAdmin/createMenu"
                                        render={(rest) => {
                                            if (loggedInUserInfo.menuByYear) {
                                                return <YearMeal {...rest} menuId={0} schoolGrades={this.state.grades} lType={lType} />
                                            }
                                            return <CreateMenu {...rest} menuId={0} schoolGrades={this.state.grades} lType={lType} />
                                        }} />
                                    <Route path="/schoolAdmin/editMenu"
                                        render={(rest) => <CreateMenu {...rest} menuId={schoolMealId} lType={lType} schoolGrades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/viewMenu" render={(rest) => <ViewMenuV2 {...rest} readSchoolMealId={this.readSchoolMealId} />} />
                                    <Route path="/schoolAdmin/menuManage" render={(rest) => <ItemAssign {...rest} />} />
                                    <Route path="/schoolAdmin/datasync" component={DataSync} />
                                    <Route path="/schoolAdmin/manageSchools" component={ManageSchools} />
                                    <Route path='/schoolAdmin/manageSchoolRec' component={SchoolYearRec} />
                                    <Route path="/schoolAdmin/manageUsers" component={ManageUsers} />
                                    <Route path="/schoolAdmin/viewReports"
                                        render={() => <ViewReportsV2 grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/alAcarte"
                                        render={() => <AlAcarte />} />
                                    <Route path="/schoolAdmin/adminReports"
                                        render={() => <AdminReports grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/paymentReports" render={(rest) => <PaymentReports {...rest} grades={this.state.grades} />} />
                                    <Route path="/schoolAdmin/accountHistory/:id?" render={() => <AccountHistory />} />
                                    <Route path="/schoolAdmin/account/:action?" component={account} />
                                    <Route path="/schoolAdmin/cancelorders"
                                        render={(rest) => <CancelOrder {...rest} schoolGrades={this.state.grades} />} />
                                    <Route path={"/schoolAdmin/menu/:id/:mealType/:status"} render={() => <OrderMenu />} />
                                    {/* <Route path={"/schoolAdmin/menu/:id/:status"} render={() => <ViewMenu menuYearMonth={this.state.orderMonthYear} />} /> */}
                                    <Route path="/schoolAdmin/lowBalEmail" component={LowBalEmailEntry} />
                                    <Route path='/schoolAdmin/dashboardCharts' component={DashboardCharts} />
                                    <Route path='/schoolAdmin/menuMaster/:id?' component={MenuMaster} />
                                    <Route path='/schoolAdmin/menuMasterList' component={MenuMasterList} />
                                    <Route path='/schoolAdmin/newMenu' component={NewMenu} />
                                    <Route path='/schoolAdmin/managePackage' component={ManagePackage} />
                                    <Route path='/schoolAdmin/manageBcAc' render={() => <ManageBcAC grades={this.state.grades} />} />
                                    <Route path='/schoolAdmin/signInAndSignOut' render={() => <ManageBcAC grades={this.state.grades} title={`Sign in / Sign Out`} />} />
                                    <Route path='/schoolAdmin/schoolMealProgram'
                                        render={(rest) => <SchoolLunchProgramList {...rest} />} />
                                    <Route path='/schoolAdmin/newSchoolMealProgram'
                                        render={(rest) => <NewLunchApplication {...rest} />} />
                                    <Route path='/schoolAdmin/newSchoolMealProgramApplication'
                                        render={(rest) => <NewSchoolMealProgramApplication {...rest} />} />

                                    <Route path='/schoolAdmin/supportRequest' render={() => <ContactUS />} />
                                    <Route path='/schoolAdmin/broadcastMessage' render={() => <BroadcastMessage />} />
                                    <Route path='/schoolAdmin/eligibilityCodeSettings' render={() => <EligibilityCodes />} />
                                    <Route path='/schoolAdmin/directCertificationSettings' render={() => <DirectCertification />} />
                                    <Route path='/schoolAdmin/editEligibilityLetter' render={(props) => <EditEligibilityLetter {...props} />} />
                                    <Route path='/schoolAdmin/notSubmittedNotification' render={(props) => <NotSubmittedNotification {...props} />} />
                                    <Route path='/schoolAdmin/poslocation'
                                        render={() => <POSLocation />} />
                                    <Route path='/schoolAdmin/nutrition'
                                        render={() => <NutritionPage />} />
                                    <Route path='/schoolAdmin/enrollmentSummary'
                                        render={() => <EnrollmentSummary />} />
                                    <Route path='/schoolAdmin/enrollments'
                                        render={() => <Enrollments />} />
                                    <Route path="/schoolAdmin/eseaFormList" render={() => <ESEAFormList />} />
                                    <Route path='/schoolAdmin/lunchSessions' render={() => <LunchSessions />} />
                                    <Route path='/schoolAdmin/lunchSessionRecord/:id?' render={() => <SessionRecord />} />
                                    <Route path='/schoolAdmin/dailyPosCash' render={() => <DailyPOSCash />} />
                                    <Route path='/schoolAdmin/bulkTransaction' render={() => <BulkTransactions />} />
                                    <Route path="/schoolAdmin/automateSchoolYear" component={AutomateSchoolYear} />
                                    <Route path='/:domain?/studentRegistration'
                                        exact={true} render={(props) => <StudentRegistration {...props} />} />
                                    <Route path="/schoolAdmin/help" component={Help} />
                                    <Route component={() => {
                                        return <DashBoard />
                                    }} />
                                </Switch>

                            </Fragment>
                            }


                        </ErrorBoundary>
                    </div>
                </Router>
            </div>
        );
    }

}

export default schoolAdmin;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/schoolAdminHome.jsx